import React from "react";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

// Utility function to remove duplicate objects from an array based on a unique key
const removeDuplicates = (data, key) => {
  return [...new Map(data?.map((item) => [item[key], item])).values()];
};

const Table = (props) => {
  // Assuming `rows` is passed as a prop, sanitize it before using
  const { columns, rows } = props;

  // Remove duplicates from rows based on a unique identifier, for example, 'id'
  const uniqueRows = removeDuplicates(rows, "id");

  return (
    <Box style={{ height: "60vh", width: "98%" }}>
      <DataGrid
        columnVisibilityModel={{
          id: false,
        }}
        components={{
          Toolbar: GridToolbar,
        }}
        rows={uniqueRows} // Use the sanitized rows
        columns={columns}
        initialState={{ pinnedColumns: { right: ["actions"] } }}
        sx={{
          "& .MuiDataGrid-iconSeparator": {
            display: "none",
          },
           "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "rgba(0, 165, 162, 0.7)",
            color: "white",
            fontWeight: "bold",
          },
           "& .MuiDataGrid-toolbarContainer": {
            color: "rgba(0, 165, 162, 0.7)",
          },
          "& .MuiDataGrid-pinnedColumnHeaders": {
            boxShadow: "none",
            backgroundColor: "transparent",
          },
          "& .MuiDataGrid-pinnedColumns": {
            boxShadow: "none",
            backgroundColor: "transparent",
            "& .MuiDataGrid-cell": {
              padding: 0,
            },
          },
          "& .MuiDataGrid-row": {
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "whitesmoke",
            },
            "&:first-of-type": {
              borderTop: "1px solid rgba(0, 165, 162, 0.7)",
            },
          },
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-cell:focus-within": {
            outline: "none",
          },
        }}
      />
    </Box>
  );
};

export default Table;
